import { render } from "./KanbanCard.vue?vue&type=template&id=edeb759a&scoped=true"
import script from "./KanbanCard.vue?vue&type=script&lang=js"
export * from "./KanbanCard.vue?vue&type=script&lang=js"

import "./KanbanCard.vue?vue&type=style&index=0&id=edeb759a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edeb759a"]])

export default __exports__